const Infos = ({ ...props }) => {
  return (
    <svg
      {...props}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0002 17.9163C12.1863 17.9163 14.1654 17.0302 15.5981 15.5976C17.0307 14.1649 17.9168 12.1858 17.9168 9.99967C17.9168 7.81357 17.0307 5.8344 15.5981 4.40174C14.1654 2.96911 12.1863 2.08301 10.0002 2.08301C7.81405 2.08301 5.83489 2.96911 4.40223 4.40174C2.9696 5.8344 2.0835 7.81357 2.0835 9.99967C2.0835 12.1858 2.9696 14.1649 4.40223 15.5976C5.83489 17.0302 7.81405 17.9163 10.0002 17.9163Z"
        stroke="#B6B6BA"
        stroke-width="1.6"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11 6.0412C10.9996 5.48892 10.5515 5.04156 9.99921 5.04199C9.44692 5.04243 8.99956 5.4905 9 6.04278L9.00346 10.4147C9.0039 10.967 9.45197 11.4144 10.0043 11.4139C10.5565 11.4135 11.0039 10.9654 11.0035 10.4131L11 6.0412ZM11.25 13.9116C11.25 13.2213 10.6904 12.6616 10 12.6616C9.30964 12.6616 8.75 13.2213 8.75 13.9116V13.9549C8.75 14.6453 9.30964 15.2049 10 15.2049C10.6904 15.2049 11.25 14.6453 11.25 13.9549V13.9116Z"
        fill="#B6B6BA"
      />
    </svg>
  )
}

export default Infos
